import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * Lightweight breadcrumb trail for dashboard sections.
 */
export function Breadcrumbs({ items, className }) {
  if (!items?.length) return null;
  return (
    <nav aria-label="Breadcrumb" className={cn('min-w-0', className)}>
      <ol className="flex flex-wrap items-center gap-1 text-xs font-semibold text-slate-500 sm:text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="inline-flex min-w-0 items-center gap-1">
              {index > 0 ? (
                <ChevronRight className="h-3.5 w-3.5 shrink-0 text-slate-300" aria-hidden />
              ) : null}
              {item.href && !isLast ? (
                <a
                  href={item.href}
                  onClick={item.onClick}
                  className="truncate text-slate-500 transition-colors hover:text-violet-700"
                >
                  {item.label}
                </a>
              ) : (
                <span
                  className={cn('truncate', isLast ? 'font-bold text-slate-800' : 'text-slate-500')}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
